import get from "lodash/get";
import {findRelation} from "../../api/utils";
import TymberItem from "./cartItem";
import Orderable from "./orderable";
import SimpleOrder from "../../common/models/simpleOrder";
import Customer from "src/core/common/models/customer";

class TymberOrder extends SimpleOrder {
  cachedItems = null;

  constructor(orderObject) {
    super(orderObject.data, orderObject.included);
    this.orderObject = orderObject;
    this.orderable = new Orderable(this.orderObject, this.orderObject);
  }

  getItems() {
    if (!this.cachedItems) {
      this.cachedItems = this.orderObject.data.relationships.items.data.map(
        (relation) => {
          const item = findRelation(this.orderObject.included, relation);
          return new TymberItem(
            {
              data: item,
              included: this.orderObject.included,
            },
            item
          );
        }
      );
    }
    return this.cachedItems;
  }

  getCustomer() {
    const customerRelationship = get(
      this.orderObject,
      "data.relationships.customer.data"
    );
    const customerObject = findRelation(this.orderObject.included, customerRelationship);

    return new Customer(customerObject);
  }

  getName() {
    return this.orderObject.data.attributes.notes;
  }

  getPrices() {
    return this.orderable.getPrices();
  }
  getTaxDetails() {
    return this.orderable.getTaxDetails();
  }
  hasDiscount() {
    return this.orderable.hasDiscount();
  }
  getPromoCode() {
    return this.orderable.getPromoCode();
  }
  getPromoCodes() {
    return this.orderable.getPromoCodes();
  }
  getDiscounts() {
    return this.orderable.getDiscounts();
  }
  getNotes() {
    return this.orderable.getNotes();
  }
}

export default TymberOrder;
